import { webKnots } from '../../../../common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'

export const wi8Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor

  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 20, 1, 1)
  // 捕球面＿折り返し上パーツ
  // onCatchFaceParts(ctx, webColor, stitchColor)
  // 縦パーツ
  verticalPartOfFenceWeb(ctx, webColor, laceColor, stitchColor)
  // 捕球面上のウェブ結び目
  webKnots(ctx, laceColor, -110, 110)
}

// 縦パーツ
const verticalPartOfFenceWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.fillStyle = webColor
  // 縦パーツ_左
  ctx.beginPath()
  ctx.moveTo(606, 93) //左上
  ctx.quadraticCurveTo(483, 289, 483, 289) //左下
  ctx.quadraticCurveTo(506, 320, 506, 320) //右下
  ctx.quadraticCurveTo(637, 127, 637, 127) //右上
  ctx.quadraticCurveTo(614, 100, 606, 93) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 縦パーツ_右
  ctx.beginPath()
  ctx.moveTo(665, 170) //左上
  ctx.quadraticCurveTo(525, 341, 525, 341) //左下
  ctx.quadraticCurveTo(549, 367, 549, 367) //右下
  ctx.quadraticCurveTo(684, 207, 684, 207) //右上
  ctx.quadraticCurveTo(681, 195, 665, 170) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])

  // 縦向き＿左
  // 左
  ctx.moveTo(608, 98) // 上
  ctx.quadraticCurveTo(486, 288, 488, 288) // 下
  // 右
  ctx.moveTo(634, 125) // 上
  ctx.quadraticCurveTo(505, 313, 505, 315) // 下
  // 縦向き＿左
  // 左
  ctx.moveTo(665, 175) // 上
  ctx.quadraticCurveTo(531, 340, 531, 340) // 下
  // 右
  ctx.moveTo(681, 205) // 上
  ctx.quadraticCurveTo(549, 361, 549, 361) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}
